import { createPlacementComponent as createPlacementComponentActual } from '@post-office/placement-contexts/create-placement-component';
import {
	type PlacementComponent,
	type PlacementConfigurationOptions,
} from '@post-office/placement-contexts/create-placement-component/types';

export const createPlacementComponent = <P,>(
	placementId: string,
	Component: PlacementComponent<P>,
	placementConfigurationOptions?: PlacementConfigurationOptions,
) => createPlacementComponentActual(placementId, Component, placementConfigurationOptions);
